module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO VERTICAL-5630f9464aa863065b0a7d53c8b30304.png";